import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import PropTypes from 'prop-types';
import SnackStore from '../../stores/SnackStore';
import Table from '../Fuse/Table';
import { Card } from '../Fuse';
import FuseMenu from '../FuseControls/FuseMenu';
import { fetchDisplayRoleName, ModalMode } from '../../stores/Administrators/AdministratorModalStore';
import AdministratorModal from './AdministratorModal';
import AdministratorsStore from '../../stores/Administrators/AdministratorsStore';
import './Administrators.css';

const block = b.lock('Administrators');

class Administrators extends Component {
    static propTypes = {
        store: AdministratorsStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
        currentUserId: PropTypes.number.isRequired,
        header: PropTypes.string,
        addFirstAdminLink: PropTypes.string,
        modalSubtitle: PropTypes.string,
        readOnly: PropTypes.bool,
        sendInvitationOption: PropTypes.bool,
    };

    columns = [
        {
            name: 'email',
            title: 'Email',
            sortable: true,
            render: (item) => item.email,
        },
        {
            name: 'firstName',
            title: 'First Name',
            render: (item) => item.firstName,
        },
        {
            name: 'lastName',
            title: 'Last Name',
            render: (item) => item.lastName,
        },
        {
            name: 'role',
            title: 'Role',
            render: (item) => <Fragment>
                {fetchDisplayRoleName(item.role) + ' '}
                {item.isPrimary ? <span className={block('PrimaryAdminLabel')}>(Primary Admin)</span> : null}
            </Fragment>,
        },
        {
            name: 'menu',
            title: '',
            render: (item) => {
                const actions = [
                    {
                        label: 'Edit Admin…',
                        icon: 'edit',
                        disabled: item.isPrimary,
                        onClick: () => this.props.store.openModal(ModalMode.EDIT, item),
                    },
                    {
                        label: 'Delete Admin',
                        icon: 'delete',
                        disabled: item.isPrimary || Number(item.id) === Number(this.props.currentUserId),
                        onClick: () => this.props.store.openModal(ModalMode.DELETE, item),
                    },
                ];
                if (this.props.sendInvitationOption) {
                    actions.splice(1, 0, {
                        label: 'Resend Invitation',
                        icon: 'email',
                        onClick: () => this.sendInvitation(item),
                    });
                }
                return <FuseMenu
                    open={this.props.store.menu.id === item.id}
                    toggle={() => this.props.store.menu.toggle(item.id)}
                    items={actions}
                />;
            },
        },
    ];

    actions = [
        {
            label: 'New Admin',
            icon: 'add',
            onPress: () => this.props.store.openModal(ModalMode.CREATE),
        },
    ];

    componentWillMount() {
        this.props.store.search.setValue('');
        this.loadUsers(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.store !== this.props.store && nextProps.store.users.length === 0) {
            this.loadUsers(nextProps);
        }
    }

    loadUsers = (props) => {
        props.store.load().catch((error) => this.props.snack.showError(`Failed to load admins: ${error.message}`));
    };

    onUserClick = (item) => {
        const { openModal, menu } = this.props.store;
        if (!menu.isOpen()) {
            openModal(ModalMode.VIEW, item);
        }
    };

    sendInvitation = (user) => {
        const { store, snack } = this.props;
        store.sendInvitation(user)
            .then((sent) => sent && snack.showSuccess(`Invitation has been resent to the administrator ${user.email}.`))
            .catch((error) => snack.showError(`Failed to send invitation. ${error ? error.message : ''}.`));
    };

    render() {
        const { store, header, addFirstAdminLink, modalSubtitle, sendInvitationOption, readOnly } = this.props;
        const { users, listStatus, search, sortBy, totalUsersCount, openModal } = store;
        if (readOnly) {
            this.columns = this.columns.filter((column) => column.name !== 'menu');
        }
        return <Fragment>
            <Card className={block('TableCardContainer')}>
                <Table
                    header={header}
                    cellClassName={block('UsersCell')}
                    items={users}
                    loading={listStatus.isLoading}
                    columns={this.columns}
                    actions={readOnly ? null : this.actions}
                    searchPlaceholder="Search by Name or Email"
                    search={search}
                    onSort={sortBy}
                    onRowClick={this.onUserClick}
                    noItemsText={totalUsersCount() === 0 && !readOnly ? (
                        <div className={block('AddUserLink')}>
                            Get started by&nbsp;
                            <a
                                className={block('AddFirstItemLink')}
                                onClick={() => openModal(ModalMode.CREATE)}
                            >
                                {addFirstAdminLink || 'adding a User administrator'}
                            </a>
                        </div>
                    ) : null}
                />
            </Card>

            <AdministratorModal
                subtitle={modalSubtitle}
                readOnly={readOnly}
                store={store}
                sendInvitation={sendInvitationOption}
            />
        </Fragment>;
    }
}

export default inject('snack')(observer(Administrators));
